import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import SwiperCore, {
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
} from "swiper";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllVideos } from "@store/action/multimedia/VideoAction";
SwiperCore.use([
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
]);
const params = {
  slidesPerView: 3,
  spaceBetween: 30,
  pagination: false,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  navigation: false,
};
const URL = process.env.REACT_APP_MICRO_MULTIMEDIA_URL;

const VideoSection = ({ t }) => {
  const dispatch = useDispatch();
  const Videos = useSelector((state) => state.VideoReducer);
  useEffect(() => {
    dispatch(
      getAllVideos({
        page: 1,
        per_page: 5,
      })
    );
  }, [dispatch]);

  return (
    <section className="section video-part">
      <div className="container__">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-heading">
              <h2>{t("Video Gallery")}</h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="video-slider slider-arrow">
              <Swiper {...params}>
                {Videos?.data?.map((el, i) => (
                  <SwiperSlide key={i}>
                    <div className="video-vid" style={{ height: "300px" }}>
                      <video
                        src={el.file_path}
                        style={{ height: "100%", objectFit: "cover" }}
                      />
                      <div className="video-overlay">
                        <Link
                          className="venobox icon icon-inline"
                          data-autoplay="true"
                          data-vbtype="video"
                          to={`/Gallery/Video/${el.id}`}
                        >
                          <i className="fa fa-play"></i>
                        </Link>
                      </div>
                    </div>
                    <div className="video-content">
                      <h5>{el.file_name}</h5>
                      <p>{el.video_info?.length_text}</p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="team-btn">
              <Link className="btn btn-outline" to="/Gallery/Videos/topics">
                <i className="fa fa-eye me-1"></i>
                <span>{t("show more")}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
